import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '../ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_909b0cd9-ab53-4cdb-baf5-2cde0d59c9a0/artifacts/fylrv7fv_horizontal%20Logos%20Full%20Color%20%282%29.png";

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Record Suspension', path: '/record-suspensions' },
  { name: 'U.S. Entry Waivers', path: '/us-entry-waivers' },
  { name: 'International Filings', path: '/international-filings' },
  { name: 'Eligibility Assessment', path: '/eligibility' },
  { name: 'Contact', path: '/contact' },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm" data-testid="header">
      {/* Top Bar */}
      <div className="gov-header-top">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
          <span className="text-white/80 text-xs">Government Application Processing</span>
          <div className="flex items-center gap-4">
            <a href="tel:+18665543535" className="flex items-center gap-1 text-white/90 hover:text-white text-xs">
              <Phone className="h-3 w-3" />
              <span>(866) 554-3535</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="gov-header-main py-3 lg:py-5">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
            <img 
              src={LOGO_URL} 
              alt="Canadian Document Services" 
              className="h-10 md:h-12 lg:h-14 w-auto"
            />
          </Link>

          {/* Desktop Right Side */}
          <div className="hidden lg:flex items-center gap-4">
            <Link to="/eligibility">
              <Button className="gov-btn-primary" data-testid="header-cta-btn">
                Check Eligibility
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-[hsl(215,50%,23%)]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle mobile menu"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className="gov-nav-bar hidden lg:block" data-testid="desktop-nav">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`gov-nav-link ${isActive(link.path) ? 'bg-white border-b-2 border-[hsl(215,50%,23%)]' : ''}`}
                data-testid={`nav-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </nav>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200" data-testid="mobile-nav">
          <nav className="flex flex-col py-4 px-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`block px-4 py-3 text-[hsl(215,50%,23%)] hover:bg-gray-100 border-b border-gray-100 ${isActive(link.path) ? 'bg-gray-100 font-semibold' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 px-4">
              <Link to="/eligibility" onClick={() => setMobileMenuOpen(false)}>
                <Button className="gov-btn-primary w-full">
                  Check Eligibility
                </Button>
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
